import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { arrayToObject, objectToArray } from "./Constants";
import { debounce } from "lodash";
import { getFlowById, setFlowById } from "../../services/flowService";
import { getfinalDataObj } from "./common/common";
import AddVariablePopup from "./AddVariablePopup";

const FlowChartEdit = () => {
  const [nodes, setNodes] = useState([]);
  const [interruptions, setInterruptions] = useState([]);
  const [variables, setVariables] = useState([]);

  const textAreaRef = useRef(null);

  useEffect(() => {
    textAreaRef.current.style.height = "auto";
    textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
  }, [nodes]);

  const params = useParams();

  // have to make two because of debouncing
  const debouncedSetFlowAPINodes = useRef(
    debounce((dataObj) => setFlowById(params.id, dataObj), 500)
  ).current;

  const debouncedSetFlowAPIInterruptions = useRef(
    debounce((dataObj) => setFlowById(params.id, dataObj), 500)
  ).current;

  const textareaRefs = useRef([]);

  useEffect(() => {
    textareaRefs.current.forEach((ref, index) => {
      if (ref) {
        ref.style.height = "auto";
        ref.style.height = `${ref.scrollHeight}px`;
      }
    });
  }, [nodes]);

  // intial flow data from backend
  const [dataFetched, setDataFetched] = useState(false);
  const getFlowData = async () => {
    const flow = await getFlowById(params.id);
    if (flow) {
      if (flow.initial_nodes) {
        setNodes(flow.initial_nodes);
      }
      if (flow.interruptions) {
        setInterruptions(flow.interruptions);
      }
      if (flow.variables) {
        setVariables(flow.variables.variables);
      }
    }
    setDataFetched(true);
  };

  useEffect(() => {
    getFlowData();
  }, [params.id]);

  //   const debouncedSetBackendJson = useRef(
  //     debounce((dataObj) => {
  //       setFlowById(params.id, dataObj);
  //     }, 500)
  //   ).current;

  const finalData = useMemo(() => {
    if (!dataFetched) return false;
    return getfinalDataObj(nodes, interruptions);
  }, [nodes, interruptions, dataFetched]);

  //   useEffect(() => {
  //     if (finalData) {
  //       debouncedSetBackendJson({ backend_json: finalData });
  //     }
  //   }, [finalData, debouncedSetBackendJson]);

  const onChangeHandler = (event) => {
    setNodes(event.target.value);
    event.target.style.height = "auto";
    event.target.style.height = `${event.target.scrollHeight}px`;
  };

  const onNodeInputChange = (e, id, lang) => {
    const nodesObj = arrayToObject(nodes);
    nodesObj[id]["message"][lang] = e.target.value.replace(/\n/g, "");
    const updatedNodes = objectToArray(nodesObj);
    setNodes(updatedNodes);

    debouncedSetFlowAPINodes({ initial_nodes: nodes });
  };

  const onInterruptionInputChange = (e, id, lang) => {
    const interrutptionsObj = arrayToObject(interruptions);
    interrutptionsObj[id]["message"][lang] = e.target.value.replace(/\n/g, "");
    const updatedInterruptions = objectToArray(interrutptionsObj);
    setInterruptions(updatedInterruptions);

    debouncedSetFlowAPIInterruptions({ interruptions: updatedInterruptions });
  };

  const onFillerUsedChange = (e, id) => {
    const nodesObj = arrayToObject(nodes);
    nodesObj[id]["filler_used"] = e.target.checked;
    const updatedNodes = objectToArray(nodesObj);
    setNodes(updatedNodes);

    debouncedSetFlowAPINodes({ initial_nodes: nodes });
  };

  // Saving backend json
  const [sbButtonText, setSbButtonText] = useState("Save Backend Json");
  const [sbLoading, setSbLoading] = useState(false);

  const saveBackendJson = async () => {
    setSbLoading(true);
    const res = await setFlowById(params.id, { backend_json: finalData });
    if (res.status === 200) {
      setSbLoading(false);
      setSbButtonText("Saved!");
      setTimeout(() => {
        setSbButtonText("Save Backend Json");
      }, 1000);
    }
  };

  //adding variables

  const addVariable = async (name, type) => {
    const response = await setFlowById(params.id, {
      variables: {
        variables: [
          ...variables,
          { name: name, type: type, value_required: true },
        ],
      },
    });
    await getFlowData();
    return response;
  };

  // const editVariable = async (name) => {
  //   var editIndex = variables.map((item) => item.name).indexOf(name);

  //   if (editIndex !== -1) {
  //     variables[editIndex].value_required = true;
  //   }
  //   const response = await setFlowById(params.id, {
  //     variables: {
  //       variables: [...variables],
  //     },
  //   });
  //   return response;
  // };

  const deleteVariable = async (name) => {
    var removeIndex = variables.map((item) => item.name).indexOf(name);

    ~removeIndex && variables.splice(removeIndex, 1);

    const response = await setFlowById(params.id, {
      variables: {
        variables: [...variables],
      },
    });
    await getFlowData();

    return response;
  };

  const [addVariablePopup, setAddVariablePopup] = useState(false);

  const toggleAddVariablePopup = () => {
    setAddVariablePopup((prev) => !prev);
  };

  return (
    <>
      <div className="p-20 pt-4">
        <div className="flex w-full">
          <button
            className={`bg-black text-white px-4 py-2 rounded ml-auto ${
              sbLoading ? "bg-gray-300 text-slate-600" : "bg-black border-black"
            } ${sbButtonText === "Saved!" && "bg-slate-400"}`}
            disabled={sbLoading || sbButtonText === "Saved!"}
            onClick={saveBackendJson}>
            {sbButtonText}
          </button>
        </div>
        <div className="flex mt-8 mb-8 items-center gap-2">
          <div className="ml-4 font-medium">Variables</div>
          <button
            className={`bg-black text-white px-4 py-2 rounded`}
            onClick={toggleAddVariablePopup}>
            Add
          </button>
        </div>
        {addVariablePopup && (
          <AddVariablePopup
            toggleAddVariablePopup={toggleAddVariablePopup}
            addVariable={addVariable}
          />
        )}
        <div className="relative rounded-xl overflow-auto">
          <div className="shadow-sm overflow-hidden my-8">
            <table className="border-collapse table-fixed w-full text-sm">
              <thead>
                <tr>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pl-8 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    Name
                  </th>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    Type
                  </th>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left"></th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800">
                {variables.map((v, index) => {
                  return (
                    <tr key={v.name}>
                      <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-400">
                        {v.name}
                      </td>
                      <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400">
                        {v.type}
                      </td>
                      <td
                        className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400 ml-4  pl-8"
                        onClick={() => {
                          deleteVariable(v.name);
                        }}>
                        <button className="bg-gray-300 rounded px-2 py-[0.5px] border-2 border-transparent hover:bg-gray-400 focus:ring-2 focus:ring-blue-800">
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="absolute inset-0 pointer-events-none border border-black/5 rounded-xl dark:border-white/5"></div>
        </div>
        <div className="ml-4 mt-8 mb-8 font-medium">Bot Messages</div>
        <div className="relative rounded-xl overflow-auto">
          <div className="shadow-sm overflow-hidden my-8">
            <table className="border-collapse table-fixed w-full text-sm">
              <thead>
                <tr>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pl-8 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    En
                  </th>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    Hi
                  </th>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left w-[10%]">
                    Filler used
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800">
                {nodes
                  .filter((nd) => nd.type === "botMsgNode")
                  .map((nd, index) => {
                    return (
                      <tr key={nd.id}>
                        <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-400">
                          <textarea
                            ref={(el) => (textareaRefs.current[2 * index] = el)}
                            className="border rounded border-slate-300 w-full"
                            onChange={(e) => {
                              onNodeInputChange(e, nd.id, "en");
                            }}
                            value={nd.message.en}
                          />
                        </td>
                        <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400">
                          <textarea
                            ref={(el) =>
                              (textareaRefs.current[2 * index + 1] = el)
                            }
                            className="border rounded border-slate-300 w-full"
                            onChange={(e) => {
                              onNodeInputChange(e, nd.id, "hi");
                            }}
                            value={nd.message.hi}
                          />
                        </td>
                        <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400 text-center">
                          <input
                            onChange={(e) => {
                              onFillerUsedChange(e, nd.id);
                            }}
                            className=""
                            type="checkbox"
                            id="imp_msg"
                            name="imp_msg"
                            value="imp_msg"
                            checked={nd.filler_used}
                          />
                          <label className="ml-2" htmlFor="imp_msg"></label>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="absolute inset-0 pointer-events-none border border-black/5 rounded-xl dark:border-white/5"></div>
        </div>
        <div className="ml-4 my-8 font-medium">Interruptions</div>
        <div className="relative rounded-xl overflow-auto">
          <div className="shadow-sm overflow-hidden my-8">
            <table className="border-collapse table-fixed w-full text-sm">
              <thead>
                <tr>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pl-8 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    En
                  </th>
                  <th className="border-b dark:border-slate-600 font-medium p-4 pt-0 pb-3 text-slate-500 dark:text-slate-200 text-left">
                    Hi
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-slate-800">
                {interruptions.map((interruption) => {
                  return (
                    <tr key={interruption.id}>
                      <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 pl-8 text-slate-500 dark:text-slate-400">
                        <textarea
                          className="border rounded border-slate-300 w-full"
                          onChange={(e) => {
                            onInterruptionInputChange(e, interruption.id, "en");
                          }}
                          value={interruption.message.en}
                        />
                      </td>
                      <td className="border-b border-r border-slate-100 dark:border-slate-700 p-4 text-slate-500 dark:text-slate-400">
                        <textarea
                          className="border rounded border-slate-300 w-full"
                          onChange={(e) => {
                            onInterruptionInputChange(e, interruption.id, "hi");
                          }}
                          value={interruption.message.hi}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="absolute inset-0 pointer-events-none border border-black/5 rounded-xl dark:border-white/5"></div>
        </div>

        <textarea
          className="w-full rounded-[6px] mt-8"
          ref={textAreaRef}
          rows={1}
          value={JSON.stringify(nodes, null, 2)}
          onChange={onChangeHandler}
          style={{ overflow: "hidden" }}
        />
      </div>
    </>
  );
};

export default FlowChartEdit;
